module.exports = __webpack_public_path__ + "img/stone101.9251b8c3.png";